import { useCurrentUser, useToastProvider } from "@qualio/ui-components";
import { useQuery } from "react-query";
import { MedtechAPI } from "../api/medtech";
import { useTranslation } from "react-i18next";

export const useTags = () => {
  const { t } = useTranslation();
  const { showToast } = useToastProvider();
  const { companyId } = useCurrentUser();

  return useQuery({
    queryKey: [companyId, "tags"],
    queryFn: () => MedtechAPI.getDocumentTags(companyId),
    onError: () => {
      showToast({
        title: t("common.notifications.fetchError.title"),
        description: t("common.notifications.fetchError.description"),
        status: "error",
      });
    },
  });
};
